import clsx from 'clsx';
import { productImageUrl, SystemProductImage } from 'utils/system-products';
import ProductImageTile from './product-image-tile';

type ProductImageStripProps = Readonly<{
  products: SystemProductImage[];
  className?: string;
}>;

export default function ProductImageStrip({
  products,
  className
}: ProductImageStripProps) {
  if (products.length === 0) return null;

  return (
    <div
      data-testid='product-image-strip'
      className={clsx('flex items-center gap-2', className)}
    >
      {products.map((item) => (
        <ProductImageTile key={item.key}>
          <img
            src={productImageUrl(item.product.photo)}
            alt={item.product.name}
            className='h-full w-full object-contain'
          />
        </ProductImageTile>
      ))}
    </div>
  );
}
